import { readEnv } from "@pgs-core/portal-lib/config";

export type AdminConfig =
  | { ok: false; message: string }
  | {
      ok: true;
      supabaseUrl: string;
      publishableKey: string;
      apiBaseUrl: string;
      clientPortalUrl: string;
    };

export function readConfig(): AdminConfig {
  const env = import.meta.env;
  const supabaseUrl = readEnv(env, "PUBLIC_SUPABASE_URL", "VITE_SUPABASE_URL");
  const publishableKey = readEnv(env, "PUBLIC_SUPABASE_PUBLISHABLE_KEY", "VITE_SUPABASE_PUBLISHABLE_KEY");

  if (!supabaseUrl || !publishableKey) {
    return {
      ok: false,
      message: "Set PUBLIC_SUPABASE_URL and PUBLIC_SUPABASE_PUBLISHABLE_KEY before running the admin portal.",
    };
  }

  return {
    ok: true,
    supabaseUrl,
    publishableKey,
    apiBaseUrl: readEnv(env, "PUBLIC_API_BASE_URL", "VITE_API_BASE_URL"),
    clientPortalUrl: readEnv(env, "PUBLIC_CLIENT_PORTAL_URL", "VITE_CLIENT_PORTAL_URL"),
  };
}
